import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import moment from "moment-timezone";

import { useRouter } from "./../../util/router";
import { useSite } from "./../../util/sites";
import GYAxios from "../../util/GYAxios";

import LoaderGraph from "../general/LoaderGraph";

function AlarmContent() {
	const router = useRouter();
	const currentSites = useSite();
	const [alarmsReady, setAlarmsReady] = useState(true);
	const [alarms, setAlarms] = useState(null);
	const [validSites, setValidSites] = useState([]);
	const [isLoaded, setIsLoaded] = useState(false);
	const [lateUpdate, setLateUpdate] = useState(false);

	const styleConfig = {
		paddingTop: "50px",
		paddingBottom: "50px",
		textAlign: "center",
		fontSize: "20px",
	};

	const containerStyle = {
		height: "89vh",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	};

	const fontStyle = {
		fontSize: "31px",
		color: "#b5b5b5",
	};

	useEffect(() => {
		GYAxios.get("/site/alarms").then((res) => {
			if (res.data != null) setValidSites(res.data);
		});

		return () => setValidSites([]);
	}, [router.pathname]);

	useEffect(() => {
		const site = currentSites.selectedSite.value;
		setAlarmsReady(true);
		let tempAlarms = {
			DGPT2_isTrip_temp: "-",
			DGPT2_isAlarm_temp: "-",
			DGPT2_isTrip_oilPressure: "-",
			DGPT2_isTrip_oilLevel: "-",
			wind_speed: "-",
			wind_dir: "-",
			water_level: "-",
			water_level: "-",
			dateData: "",
		};

		let dgpt2SitesArray = validSites.map((site) => site.table_name);

		if (
			currentSites.selectedSite != null &&
			dgpt2SitesArray.includes(site.table_name)
		) {
			let finalColumns = ["dateData"];
			const selectedSite = validSites.filter(
				(siteTemp) => siteTemp.table_name == site.table_name
			)[0];

			const alarmColumns = [
				"DGPT2_isTrip_temp",
				"DGPT2_isAlarm_temp",
				"DGPT2_isTrip_oilPressure",
				"DGPT2_isTrip_oilLevel",
			];

			if (selectedSite.DGPT2 != null && selectedSite.DGPT2 > 0)
				finalColumns = finalColumns.concat(alarmColumns);

			if (selectedSite.wind_speed != null && selectedSite.wind_speed > 0)
				finalColumns.push("wind_speed");
			if (selectedSite.wind_dir != null && selectedSite.wind_dir > 0)
				finalColumns.push("wind_dir");
			if (selectedSite.water != null && selectedSite.water > 0)
				finalColumns.push("water_level");

			const tableName = site.table_name;
			const dateData = moment().format("YYYYMMDD");
			const URI = `/p10/single_row/site/${tableName}/date/${dateData}/END`;

			// Request to get LIVE data for site
			GYAxios.get(URI).then((res) => {
				if (res.data != null) {
					res.data.map((row) => {
						row.dateData = moment(row.dateData).format("YYYY-MM-DD HH:mm");
					});
					const resAlarms = res.data[0];
					tempAlarms.dateData = resAlarms.dateData;

					const now = moment();
					if (now.diff(resAlarms.dateData, "minutes") > 15) setLateUpdate(true);

					if (selectedSite.DGPT2 != null && selectedSite.DGPT2 > 0) {
						tempAlarms.DGPT2_isTrip_temp = resAlarms.DGPT2_isTrip_temp;
						tempAlarms.DGPT2_isAlarm_temp = resAlarms.DGPT2_isAlarm_temp;
						tempAlarms.DGPT2_isTrip_oilPressure =
							resAlarms.DGPT2_isTrip_oilPressure;
						tempAlarms.DGPT2_isTrip_oilLevel = resAlarms.DGPT2_isTrip_oilLevel;
					}

					if (selectedSite.wind_speed != null && selectedSite.wind_speed > 0)
						tempAlarms.wind_speed = resAlarms.wind_speed;
					if (selectedSite.wind_dir != null && selectedSite.wind_dir > 0)
						tempAlarms.wind_dir = resAlarms.wind_dir;
					if (selectedSite.water != null && selectedSite.water > 0)
						tempAlarms.water_level = resAlarms.water_level;

					setAlarms(tempAlarms);
					setIsLoaded(true);
				} else {
					tempAlarms.DGPT2_isTrip_temp = 1;
					tempAlarms.DGPT2_isAlarm_temp = 1;
					tempAlarms.DGPT2_isTrip_oilPressure = 1;
					tempAlarms.DGPT2_isTrip_oilLevel = 1;

					tempAlarms.water_level = "-";
					tempAlarms.wind_dir = "-";
					tempAlarms.wind_speed = "-";

					setAlarms(tempAlarms);
					setIsLoaded(true);
				}
			});
		} else setAlarmsReady(false);
	}, [validSites, currentSites.selectedSite]);

	return alarmsReady && alarms != null ? (
		<div style={{ height: "89vh" }}>
			{alarms != null ? (
				<>
					{!isLoaded && <LoaderGraph style={{ height: "89vh" }} />}
					<Row>
						<Col style={styleConfig} md={3}>
							{/* <h1>Temperature Trip status: {alarms.DGPT2_isTrip_temp }</h1> */}
							<h4>
								Temperature Trip status:{" "}
								<b>{alarms.DGPT2_isTrip_temp == 0 ? "OK" : "TRIP"}</b>
							</h4>
						</Col>
						<Col style={styleConfig} md={3}>
							{/* <h4>Temperature Alarm status: {alarms.DGPT2_isAlarm_temp}</h4> */}
							<h4>
								Temperature Alarm status:{" "}
								<b>{alarms.DGPT2_isAlarm_temp == 0 ? "OK" : "ALARM"}</b>
							</h4>
						</Col>
						<Col style={styleConfig} md={3}>
							{/* <h4>Oil Pressure Trip status: {alarms.DGPT2_isTrip_oilPressure}</h4> */}
							<h4>
								Oil Pressure Trip status:{" "}
								<b>{alarms.DGPT2_isTrip_oilPressure == 0 ? "OK" : "TRIP"}</b>
							</h4>
						</Col>

						<Col style={styleConfig} md={3}>
							{/* <h4>Oil Level Trip status: {alarms.DGPT2_isTrip_oilLevel}</h4> */}
							<h4>
								Oil Level Trip status:{" "}
								<b>{alarms.DGPT2_isTrip_oilLevel == 0 ? "OK" : "TRIP"}</b>
							</h4>
						</Col>
					</Row>
					<Row>
						<Col style={styleConfig} md={4}>
							<h4>
								Wind speed: <b>{alarms.wind_speed} m/s</b>
							</h4>
						</Col>
						<Col style={styleConfig} md={4}>
							<h4>
								Wind direction: <b>{alarms.wind_dir} deg</b>
							</h4>
						</Col>
						<Col style={styleConfig} md={4}>
							<h4>
								Water level : <b>{alarms.water_level}</b>
							</h4>
						</Col>
					</Row>
					<Row>
						<Col style={styleConfig} md={12}>
							<h4>
								Last updated:{" "}
								<b style={lateUpdate ? { color: "red" } : {}}>
									{alarms.dateData}
								</b>
							</h4>
						</Col>
					</Row>
				</>
			) : (
				<LoaderGraph style={{ height: "200px" }} />
			)}
		</div>
	) : (
		<>
			{/* {!isLoaded && <LoaderGraph style={{ height: "89vh" }} />} */}
			<div style={containerStyle}>
				<h1 style={fontStyle}>No data</h1>
			</div>
		</>
	);
}

export default AlarmContent;
